import type {
  AnnotationMetadata,
  PDFAnchorFragment,
  PdfPageProxyLike,
  PdfViewportLike,
  SearchResult,
} from '../types'
import type { DomLocatorService } from '../utils/DomLocatorService'

export interface IAnnotationEngine {
  get(rawData?: unknown): AnnotationMetadata | null

  apply(annotation: AnnotationMetadata, commentId: string): boolean

  search(annotation: AnnotationMetadata): SearchResult | null

  remove(commentId: string): boolean

  removeAll(): void

  getDomLocator(): DomLocatorService
}

export abstract class AnnotationEngine implements IAnnotationEngine {
  abstract get(rawData?: unknown): AnnotationMetadata | null

  abstract apply(annotation: AnnotationMetadata, commentId: string): boolean

  abstract search(annotation: AnnotationMetadata): SearchResult | null

  abstract remove(commentId: string): boolean

  abstract removeAll(): void

  abstract getDomLocator(): DomLocatorService
}

export interface IPdfAnnotationEngine extends IAnnotationEngine {
  registerPage(
    pageIndex: number,
    refs: {
      wrapper: HTMLDivElement
      highlightCanvas: HTMLCanvasElement
      controlCanvas: HTMLCanvasElement
      bubbleLayer: HTMLDivElement
    },
    pageProxy: PdfPageProxyLike,
    viewport: PdfViewportLike,
    pageWidthPx: number,
    heightPx: number
  ): Promise<void>

  unregisterPage(pageIndex: number): void

  unregisterAllPages(): void

  handlePointerDown(event: PointerEvent, pageIndex: number): void

  handlePointerMove(event: PointerEvent): void

  handlePointerUp(event: PointerEvent): void

  handlePointerCancel(): void

  clearSelection(): void

  reset(): void

  getAnchorClientRect(fragment: PDFAnchorFragment): DOMRect | null

  getAnchorPageRect(fragment: PDFAnchorFragment): DOMRect | null
}
